import React from 'react';
import { calculateSecurityBond, shouldShowSecurityBond } from '../../../utilities/bondCalculations';
import { priceFormat } from '../../../utilities/helperUtility';
import Translation from '../../../utilities/localizationUtility';

export default function SecurityBond(props) {
  const {
    bodyStyles: { fontSize },
    cartTotal,
    price,
    totalPrice,
    settings,
  } = props;
  const { securityBondSettings } = settings;
  const t = new Translation(settings);

  if (!shouldShowSecurityBond(securityBondSettings)) return '';

  const basePrice = price || totalPrice || cartTotal || 0;
  const moneyFormat = priceFormat(settings);
  const bondCalculation = calculateSecurityBond(securityBondSettings, basePrice, moneyFormat);

  if (bondCalculation.amount <= 0) return '';

  let percentageLabel = '';
  if (securityBondSettings.bond_type === 'percentage') {
    percentageLabel = `${securityBondSettings.percentage}% `;
  }

  const securityBond = t.key('security_bond') || 'Security Bond';

  return (
    <span style={{ fontSize, margin: 'auto auto auto 0' }}>
      <span>{`${percentageLabel}${securityBond} - `}</span>
      <span
        dangerouslySetInnerHTML={{
          __html: bondCalculation.calculatedDisplay.includes('(')
            ? bondCalculation.calculatedDisplay.split('(')[1]?.replace(')', '')
            : bondCalculation.calculatedDisplay,
        }}
      />
    </span>
  );
}
